module.exports = __webpack_public_path__ + "static/media/reporting-search.9b6fe49f.svg";